import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type UserShift from "./UserShift";

@Model()
class UserShiftSpec extends ApplicationRecord {
  static jsonapiType = "user_shift_specs";

  @Attr() role: string;

  @Attr() specificationId: number;

  @Attr() startTime: number;

  @Attr() userId: number;

  @BelongsTo() userShift: UserShift;

  @Attr() userShiftId: number;
}

export default UserShiftSpec;
